import React from 'react';
import { Link } from 'react-router-dom';
import { useSiteSettings } from '../hooks/useSiteSettings';
import { ReactComponent as Logo } from '../logo.svg';

const PublicHeader: React.FC = () => {
  const { siteName, loading } = useSiteSettings();

  return (
    <header className="bg-white shadow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-3 text-xl font-semibold text-gray-900 hover:text-gray-700">
              <Logo className="h-8 w-8" />
              <span>{loading ? 'Loading...' : siteName}</span>
            </Link>
          </div>
          <nav className="flex items-center space-x-8">
            <Link to="/" className="text-gray-900 hover:text-gray-700">Home</Link>
            <Link to="/jobs" className="text-gray-900 hover:text-gray-700">Jobs</Link>
            <Link to="/page/about" className="text-gray-900 hover:text-gray-700">About</Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default PublicHeader;
